<template>
  <w-popup-show :state="state">
    <div slot="content" class="experience-dialog" :class="{'delete-experience-content': deleteIconShow}">
      <w-nav-bar :nav_title="title" icon="iconx" :right_btn_html="rightContent" @mobileLeftBtn="handleClose"
                 @mobileRightBtn="deleteShow"></w-nav-bar>
      <cube-scroll>
        <div v-if="experienceField === 'extras'" class="extras-info">
          <template v-for="(item, index) in extrasField">
            <div class="experience-item" :key="index"
                 v-if="currentExperience[item.type] && currentExperience[item.type].length">
              <p class="title">{{ item.title }}</p>
              <div class="experience-item-info" :class="{'experience-item-checked': val.checked}"
                   v-for="(val, index) in currentExperience[item.type]" :key="index"
                   @click="changeRadioCheck(val, currentExperience[item.type])">
                <div class="info flex">
                  <span v-show="deleteIconShow" class="iconfont iconshanchujianli"
                        @click.stop="deleteExperience(val, item)"></span>
                  <input v-show="!deleteIconShow" type="checkbox" class="w-radio experience-radio" :checked="val.checked">
                  <p class="description">{{ val.description }}</p>
                </div>
                <p class="flex-end update-time">更新于：{{ val.updated_at | timeFormatFilter }}</p>
              </div>
            </div>
          </template>
        </div>
        <list-component v-else :experience-data="radio ? experienceData : currentExperience" :show-box="true"
                        :show-delete="deleteIconShow" @changeCheck="changeCheck"
                        @deleteExperience="deleteExperience"></list-component>
      </cube-scroll>
      <div class="experience-footer footer flex-center" v-if="!deleteIconShow">
        <button class="experience-btn theme-button" @click="handleEnter">
          确认<span v-if="selectExperience && !radio">（{{ selectExperience }}/{{ experienceField === 'extras' ? extrasTotal : currentExperience.length }}）</span>
        </button>
      </div>
    </div>
  </w-popup-show>
</template>

<script>
	import WPopupShow from '../../components/global/w-popup-show'
	import WNavBar from '../../components/global/w-navbar'
	import { otherForm } from '../../assets/json/cv'
	import listComponent from './list-component'
	import { mapGetters, mapState } from 'vuex'
	import { addClass } from '../../assets/js/dom'

	export default {
		props: {
			state: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: '教育经历'
			},
			radio: {
				type: Boolean,
				default: false
			},
			experienceData: {
				type: Array,
				default: () => []
			}
		},
		data () {
			return {
				deleteIconShow: false
			}
		},
		mounted () {
		},
		components: {
			WPopupShow,
			WNavBar,
			listComponent
		},
		watch: {
			state () {
				this._calcDom()
			}
		},
		computed: {
			...mapGetters('cvExperience', [ 'currentExperience' ]),
			...mapState('cvExperience', [ 'experienceField' ]),
			...mapState('cv', [ 'cv' ]),
			// nav bar 右侧内容
			rightContent () {
				return this.radio ? `<span class="iconfont iconsettings"></span>` : ''
			},
			// 当前选中的个数
			selectExperience () {
				if (this.experienceField === 'extras') {
					let count = 0
					this.extrasField.forEach(item => {
						if (this.currentExperience[item.type].findIndex(v => v.checked) !== -1) count += 1
					})
					return count
				} else {
					return this.currentExperience && this.currentExperience.filter(i => i.checked).length
				}
			},
			// extras 字段整合
			extrasField () {
				if (this.experienceField === 'extras') {
					return otherForm.map(item => {
						return {
							type: `${ item.field }s`,
							title: item.labelCn
						}
					})
					// return Object.keys(this.currentExperience)
				}
			},
			extrasTotal () {
				let count = 0
				this.extrasField.forEach(item => {
					if (this.currentExperience[item.type].length) count += 1
				})
				return count
			}
		},
		methods: {
			handleClose () {
				this.$emit('handleClose')
			},
			// nav 右侧点击事件
			deleteShow () {
				this.deleteIconShow = !this.deleteIconShow
			},
			// 删除经历事件
			deleteExperience (val, item) {
				this.$emit('deleteExperience', val, item)
			},
			// 确定事件
			handleEnter () {
				if (this.radio) {
					let list = []
					if (this.experienceField === 'extras') {
						let extrasData = {
							skill: {},
							language: {},
							certificate: {},
							other: {},
							interest: {}
						}
						this.extrasField.forEach(item => {
							if (this.currentExperience[item.type].length) {
								const data = this.currentExperience[item.type].filter(val => val.checked)[0]
								extrasData[item.type.slice(0, -1)] = data || {
									name: item.title,
									description: ''
								}
							}
						})
						this.$emit('selectExperience', extrasData)
					} else {
						list = this.experienceData.filter(item => item.checked)
						this.$emit('selectExperience', list[0])
					}
				} else {
					this.$emit('handleClose')
				}
			},
			// 单选的选择
			changeRadioCheck (value, infos) {
				if (!this.deleteIconShow) {
					if (!value.checked) {
						infos.forEach(item => {
							item.checked = item.id === value.id
						})
					} else {
						value.checked = !value.checked
					}
        }
			},
			// 选择和反选
			changeCheck (info, list) {
				if ((this.radio || this.experienceField === 'skill_list' || this.experienceField === 'personal_summary') && !info.checked) {
					if (this.experienceField === 'custom') {
						this.$emit('changeCustomCheck', info)
          } else {
						list.forEach(item => {
							item.checked = item.id === info.id
						})
          }
				} else if (this.radio && info.checked) {
					info.checked = true
				} else {
					info.checked = !info.checked
				}
			},
			_calcDom () {
				this.$nextTick(() => {
					let els = document.querySelectorAll('.experience-description')
					els.forEach(item => {
						const clientHeight = item.clientHeight
						// 88为4行高度，超出4行之后显示查看更多
						if (clientHeight > 88) {
							addClass(item, 'experience-description-hide')
						}
					})
				})
			}
		}
	}
</script>
<style scoped lang="scss">
  @import '../../assets/scss/global/variable';
  @import '../../assets/scss/global/mixin';
  .experience-dialog {
    width: 100vw;
    height: $screen-height;
    background-color: $color-light;
    padding: 44px 24px 24px;
    @include ipx-content-bottom(78px);
    /deep/ .mobile-nav {
      padding-left: 24px !important;
      .iconx {
        font-size: 18px;
        color: $color-title;
      }
      .iconsettings {
        color: $color-title;
        font-size: 16px;
        font-weight: 500;
      }
    }
    .experience {
      margin-bottom: 12px;
      &:first-child {
        margin-top: 24px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .extras-info {
      .experience-item {
        margin-top: 24px;
        .title {
          margin-bottom: 4px;
          color: $color-title;
        }
        .experience-item-info {
          margin-top: 12px;
          padding: 20px;
          background-color: #f9f9f9;
          border-radius: 8px;
          color: #9c9c9c;
          .info {
            margin-bottom: 12px;
            position: relative;
            .iconshanchujianli {
              position: absolute;
              right: 0;
              color: #9c9c9c;
              font-size: 16px;
              top: 0;
              font-weight: 600;
            }
          }
          .experience-radio {
            width: 12px;
            height: 12px;
            border: 1px solid #9c9c9c !important;
            &::after {
              background-color: $color-dark-gray;
            }
          }
          .description {
            flex: 1;
            @include ellipsis(100%);
          }
          .update-time {
            font-size: $font-size-small;
          }
        }
        .experience-item-checked {
          color: $color-dark-gray;
        }
      }
    }
    .experience-footer {
      width: 100vw;
      padding: 0 24px;
      @include ipx-footer(78px, 1px);
      .experience-btn {
        width: 100%;
        height: 46px;
        border-radius: 4px;
        font-size: $font-size-medium-x;
      }
    }
  }
  .delete-experience-content {
    @include ipx-content-bottom(20px);
  }
</style>
